import Layout from '@layout/Index'

export const auditTaskSetting = [
  {
    path: '/audit-task-setting',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "audit-task-setting-table" */ './pages/AuditTaskSettingTable.vue'),
        meta: {
          title: '审单系统配置',
        },
      },
      {
        path: 'log/:id',
        component: () => import(/* webpackChunkName: "audit-task-setting-log" */ './pages/AuditTaskSettingLogPage.vue'),
        meta: {
          title: '审单系统配置日志',
        },
      },
      {
        path: 'form',
        component: () => import(/* webpackChunkName: "audit-task-setting-form-create" */ './pages/AuditTaskSettingFormPage.vue'),
        meta: {
          title: '新增审单系统配置',
        },
      },
      {
        path: 'form/:id',
        component: () => import(/* webpackChunkName: "audit-task-setting-form-update" */ './pages/AuditTaskSettingFormPage.vue'),
        meta: {
          title: '修改审单系统配置',
        },
      },
      {
        path: 'project-order-review/table',
        component: () => import(/* webpackChunkName: "audit-task-setting-project-order-review-table" */ './pages/ProjectOrderReviewStatTable.vue'),
        meta: {
          title: '项目审单统计',
        },
      },
      {
        path: 'return-order-evaluation/table',
        component: () => import(/* webpackChunkName: "audit-task-setting-return-order-evaluation-table" */ './pages/ReturnOrderEvaluationTable.vue'),
        meta: {
          title: '退单评价列表',
        },
      },
    ],
  },
]




// WEBPACK FOOTER //
// ./src/views/audit-task-setting/audit-task-setting.route.js